import { useQueryClient } from '@tanstack/react-query'
import { CircleCheck } from 'lucide-react'

import { BorStatus, type FillApplicationState, invalidateFillApplication } from '@/models/fillApplication'
import { SendAuthorizationLinkMenu } from '../SendAuthorizationLinkMenu'

/** The Documents tab's authorization links, here beside the customer's other links. */
export function AuthorizationLinks({ orgId, state }: { orgId: string; state: FillApplicationState }) {
  const queryClient = useQueryClient()

  return (
    <div className="flex flex-col gap-2">
      <h3 className="text-ink text-sm font-semibold">Authorization links</h3>
      <p className="text-ink-500 text-sm">
        The BOR lets Cai shop for insurance on their behalf. Copy a link to send, or email it to them.
      </p>
      {state.bor.status === BorStatus.SIGNED && (
        <span className="text-ink flex items-center gap-1.5 text-sm">
          <CircleCheck className="text-accent-green size-4" /> The customer has signed their BOR.
        </span>
      )}
      <div>
        <SendAuthorizationLinkMenu
          orgId={orgId}
          size="default"
          align="start"
          onSent={() => void invalidateFillApplication(queryClient, orgId)}
        />
      </div>
    </div>
  )
}
